import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import type { PopularSearchEntry } from "@/lib/contentful/popularSearches";
const FIVE_MINUTES_MS = 5 * 60_000;
export const popularSearchesQueryKey = ["contentful", "popularSearches"] as const;
async function fetchPopularSearches(): Promise<PopularSearchEntry[]> {
  const response = await fetch("/api/contentful/popular-searches");
  if (!response.ok) {
    throw new Error(`popular searches ${response.status}`);
  }
  return response.json();
}
export function usePopularSearches() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: popularSearchesQueryKey,
      queryFn: fetchPopularSearches,
      staleTime: FIVE_MINUTES_MS
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useQuery(t0);
}